import "./loginReg.css"
import Register from "../../components/Register/Register";
import Login from "../../components/Login/Login";
import { useState } from "react";
import { createBroker, createManager } from "../../helpers/createUser";
import { useNavigate } from "react-router-dom";
import house from "../../images/Modern-Home.png"
import { insertBroker, insertManager } from "../../services/Real_estate";

function LoginReg({brokers, setBrokers, managers, setManagers }) {
  const [lor, uselor] = useState({ login: false, register: false })
  const navigate = useNavigate();
  const myErevanPassword = "05055";
  const submitReg = async (e) => {
    e.preventDefault();

    const form = e.target;
    const enteredPassword = form.myErevanPassword.value;
    const newUserName = form.userName.value;
    const isManager = form.isManager.checked;

    // Проверка MyErevan Password
    if (enteredPassword !== myErevanPassword) {
      alert("❌ YOU HAVE ENTERED WRONG MYEREVAN PASSWORD");
      return;
    }

    // Проверка уникальности username
    if (
      (!isManager &&
        brokers.find((el) => el.broker_username === newUserName)) ||
      (isManager && managers.find((el) => el.manager_username === newUserName))
    ) {
      alert("❌ Такой пользователь уже существует!");
      return;
    }

    try {
      if (isManager) {
        const managerData = createManager(e); // создаем объект для бэка

        const response = await insertManager(managerData); // вызываем бэкенд
        console.log("Manager insert response:", response);

        setManagers([...managers, managerData]); // обновляем состояние
        alert("✅ Manager успешно зарегистрирован!");
      } else {
        const brokerData = createBroker(e);

        const response = await insertBroker(brokerData);
        console.log("Broker insert response:", response);

        setBrokers([...brokers, brokerData]);
        alert("✅ Broker успешно зарегистрирован!");
      }

      // Сбрасываем форму и закрываем login/register
      form.reset();
      uselor({ login: false, register: false });
    } catch (err) {
      console.error("Ошибка при регистрации:", err);
      alert("❌ Ошибка при регистрации. Попробуйте снова.");
    }
  };

  const submitLog = async (e) => {
  e.preventDefault();
  
  if (brokers.find((el) => el.broker_username === e.target.userName.value)) {
    const broker = brokers.find((el) => el.broker_username === e.target.userName.value);
    if (broker.broker_password === e.target.password.value) {
      // ← добавь это
      const token = `${broker.broker_id}_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("authToken", token);
      localStorage.setItem("userId", String(broker.broker_id));
      
      navigate(`/${broker.broker_id}`, { state: broker.broker_id });
    } else {
      alert("YOU HAVE ENTERED WRONG PASSWORD");
    }
  } else if (managers.find((el) => el.manager_username === e.target.userName.value)) {
    const manager = managers.find((el) => el.manager_username === e.target.userName.value);
    if (manager.manager_password === e.target.password.value) {
      // ← добавь это
      const token = `${manager.manager_id}_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("authToken", token);
      localStorage.setItem("userId", String(manager.manager_id));
      
      navigate(`/${manager.manager_id}`, { state: manager.manager_id });
    } else {
      alert("YOU HAVE ENTERED WRONG PASSWORD");
    }
  } else {
    alert("Такой пользователь не существует!");
  }
};
  return (
    <div className="login">
      <div className="logRegMen">
        <button onClick={() => uselor({ login: true, register: false })}>
          LOGIN
        </button>
        <button onClick={() => uselor({ login: false, register: true })}>
          REGISTER
        </button>
      </div>
      <div className="img-box">
        <img className="house" src={house} alt=""/>
        {lor.login && <Login submitLog={submitLog} />}
        {lor.register && <Register submitReg={submitReg} />}
      </div>
    </div>
  );
}

export default LoginReg;
